import { useNavigate } from "react-router-dom";
import styles from '../cssModules/index.module.css';


export default function EarRingUpdate({ id, prod, setProd, loginStatus }) {

    const apiURL = process.env.REACT_APP_SELLER;
    let jToken = localStorage.getItem('token');

    const navigate = useNavigate();

    const color = ['red', 'green', 'blue', 'grey', 'white', 'black', 'brown', 'pink', 'orange', 'yellow', 'purple', 'gold', 'silver',
        'turquoise', 'whitesmoke'];

    const design = ['Stud', 'Hoop', 'Dangle & Drop', 'Jhumki', 'Other'];

    const occesion = ['Casual', 'Formal', 'Anniversary', 'Wedding', 'Birthday', 'Baby Shower', "Valentine's Day", 'Christmas']

    const material = ['Precious Metal', 'Pearl', 'Plastic', 'Bamboo', 'Ceramic', 'Enamel', 'Fabric', 'Leather', 'Resin', 'Rubber',
        'Shell', 'Wood', 'Mother of Pearl', 'Other'
    ]

    const materialfeature = ['Lightweight', 'Hypoallergenic', 'Natural', 'Biodegradable', 'Organic', 'Recycled Materials', 'Vegan', 'Other'];

    const stone = ['Cubic Zirconia', 'Pearl', 'Diamond', 'Agate', 'Alexandrite', 'Amber', 'American Diamond', 'Amethyst', 'Glass', 'Aquamarine',
        'Crystal', 'Emerald', 'Fluorite', 'Iolite', 'Jade', 'Opal', 'Peridot', 'Quartz', 'Rhinestone', 'Ruby', 'Sapphire', 'Shell',
        'Topaz', 'Tourmaline', 'Other'
    ]

    const cut = ['Ideal', 'Very good', 'Good', 'Fair'];

    const stoneshape = ['Round', 'Heart', 'Pear', 'Asscher', 'Baguette', 'Bullet', 'Cushion', 'Emerald Cut', 'Half Moon',
        'Marquise', 'Oval', 'Princess Cut', 'Rectangular', 'Square', 'Trapezoid', 'Other'
    ]

    const weightCat = ['Category 1 (upto 500 gm)', 'Category 2 (between 500 gm to 1 kg)', 'Category 3 (between 1 to 2 kg)']

    const stock = ['In stock', 'Out of stock']


    function changeWeightCat(value) {
        switch (true) {
            case (value === 'Category 1 (upto 500 gm)'):
                return 1;
            case (value === 'Category 2 (between 500 gm to 1 kg)'):
                return 2;
            default:
                return 3;
        }
    }

    function changeWeightCatReverse(value) {
        switch (true) {
            case (Number(value) === 1):
                return 'Category 1 (upto 500 gm)';
            case ((Number(value)) === 2):
                return 'Category 2 (between 500 gm to 1 kg)';
            default:
                return 'Category 3 (between 1 to 2 kg)';
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch(`${apiURL}/change/${id}`, {
                method: 'POST',
                headers: {
                    'Content-type': 'Application/json',
                    'Authorization': `Bearer ${jToken}`
                },
                body: JSON.stringify(prod),
                credentials: 'include'
            })
            if (response.status === 200) {
                alert('Updated the product!');
                navigate('/manage');
            } else {
                await loginStatus();
                navigate('/login');
            }
        } catch (error) {
            console.log(error.message);
        }
    }

    return (
        <>
            <div className={`${styles.sellerUpdate}`}>
                <form id='uploadForm' onSubmit={handleSubmit}>
                    <div className={`${styles.updateIndividualMainDiv}`}>
                        <img src={`${apiURL}/images/${prod.photo1}`} alt='img' className={`${styles.updateIndividualImage}`} />
                        <div className={`${styles.sellerUpdateDiv}`}>

                            <div className={`${styles.sellerUploadLabelDiv}`}>
                                <label for='design'>
                                    Design
                                </label>
                                <select className={`${styles.sellerUploadSelect}`} id='design' name='design' onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                    <option value={prod.design} selected hidden>{prod.design}</option>
                                    {design.map(item => {
                                        return (
                                            <>
                                                <option value={item}>{item}</option>
                                            </>
                                        )
                                    })}
                                </select>
                            </div>

                            <div className={`${styles.sellerUploadLabelDiv}`}>
                                <label for='name'>
                                    Name
                                </label>
                                <input className={`${styles.sellerUploadSelect}`} id='name' defaultValue={prod.name} onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required={true} type='text' placeholder="Name of the product" name='name' />
                            </div>

                            <div className={`${styles.sellerUploadLabelDiv}`}>
                                <label for='color'>
                                    Color
                                </label>
                                <select className={`${styles.sellerUploadSelect}`} id='color' name='color' onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                    <option value={prod.color} selected hidden>{prod.color}</option>
                                    {color.map(item => {
                                        return (
                                            <>
                                                <option value={item}>{item}</option>
                                            </>
                                        )
                                    })}
                                </select>
                            </div>

                            <div className={`${styles.sellerUploadLabelDiv}`}>
                                <label for='occesion'>
                                    Occesion
                                </label>
                                <select className={`${styles.sellerUploadSelect}`} id='occesion' name='occesion' onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                    <option value={prod.occesion} selected hidden>{prod.occesion}</option>
                                    {occesion.map(item => {
                                        return (
                                            <>
                                                <option value={item}>{item}</option>
                                            </>
                                        )
                                    })}
                                </select>
                            </div>

                            <div className={`${styles.sellerUploadLabelDiv}`}>
                                <label for='material'>
                                    Material
                                </label>
                                <select className={`${styles.sellerUploadSelect}`} id='material' name='material' onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                    <option value={prod.material} selected hidden>{prod.material}</option>
                                    {material.map(item => {
                                        return (
                                            <>
                                                <option value={item}>{item}</option>
                                            </>
                                        )
                                    })}
                                </select>
                            </div>

                            <div className={`${styles.sellerUploadLabelDiv}`}>
                                <label for='materialfeature'>
                                    Material Feature
                                </label>
                                <select className={`${styles.sellerUploadSelect}`} id='materialfeature' name='materialfeature' onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                    <option value={prod.materialfeature} selected hidden>{prod.materialfeature}</option>
                                    {materialfeature.map(item => {
                                        return (
                                            <>
                                                <option value={item}>{item}</option>
                                            </>
                                        )
                                    })}
                                </select>
                            </div>

                            <div className={`${styles.sellerUploadLabelDiv}`}>
                                <label for='stone'>
                                    Stone
                                </label>
                                <select className={`${styles.sellerUploadSelect}`} id='stone' name='stone' onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                    <option value={prod.stone} selected hidden>{prod.stone}</option>
                                    {stone.map(item => {
                                        return (
                                            <>
                                                <option value={item}>{item}</option>
                                            </>
                                        )
                                    })}
                                </select>
                            </div>

                            <div className={`${styles.sellerUploadLabelDiv}`}>
                                <label for='cut'>
                                    Cut
                                </label>
                                <select className={`${styles.sellerUploadSelect}`} id='cut' name='cut' onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                    <option value={prod.cut} selected hidden>{prod.cut}</option>
                                    {cut.map(item => {
                                        return (
                                            <>
                                                <option value={item}>{item}</option>
                                            </>
                                        )
                                    })}
                                </select>
                            </div>


                            <div className={`${styles.sellerUploadLabelDiv}`}>
                                <label for='stock'>
                                    Stock
                                </label>
                                <select className={`${styles.sellerUploadSelect}`} id='stock' name='active' onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                    <option value={prod.active} selected hidden>{prod.active}</option>
                                    {stock.map(item => {
                                        return (
                                            <>
                                                <option value={item}>{item}</option>
                                            </>
                                        )
                                    })}
                                </select>
                            </div>

                            <div className={`${styles.sellerUploadLabelDiv}`}>
                                <label for='stoneshape'>
                                    Stone shape
                                </label>
                                <select className={`${styles.sellerUploadSelect}`} id='stoneshape' name='stoneshape' onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                    <option value={prod.stoneshape} selected hidden>{prod.stoneshape}</option>
                                    {stoneshape.map(item => {
                                        return (
                                            <>
                                                <option value={item}>{item}</option>
                                            </>
                                        )
                                    })}
                                </select>
                            </div>

                            <div className={`${styles.sellerUploadLabelDiv}`}>
                                <label for='price'>
                                    Price
                                </label>
                                <input className={`${styles.sellerUploadSelect}`} id='price' defaultValue={prod.oldPrice} onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: Number(e.target.value) }) })} required={true} type='number' placeholder="price" name='oldPrice' />
                            </div>

                            <div className={`${styles.sellerUploadLabelDiv}`}>
                                <label for='dPrice'>
                                    Discount Price
                                </label>
                                <input className={`${styles.sellerUploadSelect}`} id='dPrice' defaultValue={prod.currentPrice} onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: Number(e.target.value) }) })} required={true} type='number' placeholder="This price will be highlighted" name='currentPrice' />
                            </div>

                            <div className={`${styles.sellerUploadLabelDiv}`}>
                                <label for='weightCat'>
                                    Weight category (Courier ready)
                                </label>
                                <select className={`${styles.sellerUploadSelect}`} id='weightCat' name='weightCat' onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                    <option value={prod.weightCat} selected hidden>{changeWeightCatReverse(prod.weightCat)}</option>
                                    {weightCat.map(item => {
                                        return (
                                            <>
                                                <option value={changeWeightCat(item)}>{item}</option>
                                            </>
                                        )
                                    })}
                                </select>
                            </div>

                            <div className={`${styles.sellerUploadLabelDiv}`}>
                                <label for='stock'>
                                    In stock
                                </label>
                                <input className={`${styles.sellerUploadSelect}`} id='stock' defaultValue={prod.stock} onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: Number(e.target.value) }) })} required={true} type='number' placeholder="Available stock" name='stock' />
                            </div>
                            <div className={`${styles.sellerUploadLabelDiv}`}>
                                <label for='sku'>
                                    Stock keeping unit
                                </label>
                                <input className={`${styles.sellerUploadSelect}`} id='sku' defaultValue={prod.sku}
                                    onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required={true} type='text' placeholder="SKU" name='sku' />
                            </div>

                        </div>
                        <input type="submit" value='UPDATE' className={`${styles.sellerUpdateButton}`} />
                    </div>
                </form>
            </div>
        </>
    )
}